const buildNewUrl = (url, currentUrl, queryParams, hashBit) => {
  const encodedQuery = encodeURI(queryParams);
  const baseUrl = url || currentUrl;
  const newUrl = encodedQuery ? `${baseUrl}?${encodedQuery}` : `${baseUrl}`;
  return hashBit ? `${newUrl}#${hashBit}` : newUrl;
};

export default buildNewUrl;
